import { CommonModule } from '@angular/common';
import { Component, OnInit, HostListener } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { NgbCollapseModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ToastrService } from 'ngx-toastr';
// import { BreadcrumbComponent } from 'src/app/shared/breadcrumb/breadcrumb.component';
import { VerticalNavigationComponent } from 'src/app/shared/vertical-header/vertical-navigation.component';
import { VerticalSidebarComponent } from 'src/app/shared/vertical-sidebar/vertical-sidebar.component';
import { ImpersonationBannerComponent } from 'src/app/shared/impersonation-banner/impersonation-banner.component';
import { AuthService } from 'src/app/_services/auth.service';
import { ImpersonationService } from 'src/app/_services/impersonation.service';

@Component({
  selector: 'app-full-layout',
  standalone: true,
  imports: [
    RouterModule,
    VerticalNavigationComponent,
    VerticalSidebarComponent,
    // BreadcrumbComponent,
    ImpersonationBannerComponent,
    NgScrollbarModule,
    NgbNavModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgbCollapseModule
  ],
  templateUrl: './full.component.html',
  styleUrls: ['./full.component.scss'],
})
export class FullComponent implements OnInit {
  active = 1;
  isImpersonating = false;

  constructor(
    public router: Router,
    private authService: AuthService,
    private impersonationService: ImpersonationService,
    private toastr: ToastrService
  ) {}

  tabStatus = 'justified';

  public isCollapsed = false;

  public innerWidth: number;
  public defaultSidebar: string;
  public showSettings = false;
  public showMobileMenu = false;
  public expandLogo = false;

  options = {
    theme: 'light', // two possible values: light, dark
    dir: 'ltr', // two possible values: ltr, rtl
    layout: 'vertical', // two possible values: vertical, horizontal
    sidebartype: 'full', // four possible values: full, iconbar, overlay, mini-sidebar
    sidebarpos: 'fixed', // two possible values: fixed, absolute
    headerpos: 'fixed', // two possible values: fixed, absolute
    boxed: 'full', // two possible values: full, boxed
    navbarbg: 'skin6', // six possible values: skin(1/2/3/4/5/6)
    sidebarbg: 'skin5', // six possible values: skin(1/2/3/4/5/6)
    logobg: 'skin6', // six possible values: skin(1/2/3/4/5/6)
  };

  Logo() {
    this.expandLogo = !this.expandLogo;
  }

  ngOnInit() {
    this.defaultSidebar = this.options.sidebartype;
    this.handleSidebar();
    
    // Show staging environment warning if in staging
    this.checkStagingEnvironment();
    
    // Subscribe to impersonation state changes
    this.impersonationService.isImpersonating$.subscribe(isImpersonating => {
      this.isImpersonating = isImpersonating;
    });
    
    // Check initial impersonation state
    this.isImpersonating = this.impersonationService.isImpersonating();
  }

  @HostListener('window:resize')
  onResize() {
    this.handleSidebar();
  }

  handleSidebar() {
    this.innerWidth = window.innerWidth;
    switch (this.defaultSidebar) {
      case 'full':
      case 'iconbar':
        if (this.innerWidth < 1170) {
          this.options.sidebartype = 'mini-sidebar';
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;

      case 'overlay':
        if (this.innerWidth < 767) {
          this.options.sidebartype = 'mini-sidebar';
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;

      default:
    }
  }

  toggleSidebarType() {
    switch (this.options.sidebartype) {
      case 'full':
      case 'iconbar':
        this.options.sidebartype = 'mini-sidebar';
        break;

      case 'overlay':
        this.showMobileMenu = !this.showMobileMenu;
        break;

      case 'mini-sidebar':
        if (this.defaultSidebar === 'mini-sidebar') {
          this.options.sidebartype = 'full';
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;

      default:
    }
  }

  handleClick(event: boolean) {
    this.showMobileMenu = event;
  }
  
  isDevUser(): boolean {
    return this.authService.hasRole('dev');
  }
  
  isSidebarExpanded(): boolean {
    return this.options.sidebartype === 'full' || this.options.sidebartype === 'iconbar';
  }
  
  checkStagingEnvironment() {
    // Check if the current URL contains "staging" to determine if we're in staging environment
    if (window.location.href.includes('staging')) {
      this.toastr.warning(
        'You are currently in the STAGING environment',
        'Staging Environment',
        {
          timeOut: 0, // Never auto-dismiss
          extendedTimeOut: 0, // Never auto-dismiss on hover
          closeButton: true, // Show close button
          tapToDismiss: false, // Don't dismiss on click
          positionClass: 'toast-top-center' // Position at top center
        }
      );
    }
  }
}
